// extracted by mini-css-extract-plugin
export default {"root":"root--ujsBK","hidden":"hidden--qVc2L","squared":"squared--eSyli","default":"default--hJmsh"};